import React from 'react'
// import logo from '../../../images/home/100startups-logo.svg';

export default function ContactUs() {
    const handleEmailClick = () => {
        window.open('https://mail.google.com/mail/?view=cm&fs=1&to=support@surgestartups.com');
    };

    return (
        <div className='flex flex-col w-full h-screen justify-center items-center relative overflow-hidden p-[10px] md:p-[0px]'>
            {/* <div className='relative z-[10]'>
                <img src={logo} alt='logo'/>
            </div> */}
            <h1 className='text-[24px] sm:text-[32px] lg:text-[54px] text-[#252525] font-bold text-center'>Contact Us – Surge Students</h1>
            <h3 className='text-[#252525] font-medium text-[12px] sm:text-[14px] lg:text-[28px] mt-[30px] lg:mt-[50px] text-center relative z-[10]'>For support, payments, mentorship queries, or technical issues:</h3>
            <p className='text-[12px] sm:text-[16px] lg:text-[24px] text-[#252525] font-medium mt-[20px] z-10 relative cursor-pointer' onClick={() => { handleEmailClick() }}><span className='text-[#34C759] font-semibold'>Email: </span> support@surgestartups.com</p>
            <p className='text-[12px] sm:text-[16px] lg:text-[24px] text-[#252525] font-medium mt-[20px] z-10 relative cursor-pointer' onClick={() => { window.location.href = "/" }}><span className='text-[#34C759] font-semibold'>Website: </span> surgestudents.com</p>
            <h3 className='text-[#252525] font-medium text-[12px] sm:text-[14px] lg:text-[28px] mt-[16px] text-center'>We respond within 24–48 working hours.</h3>
        </div>
    )
}
